import * as React from "react";

export default function StartupSplash({ completed }: { completed: 1 | 2 }) {
    const message = completed === 1 ? "Checking for updates" : "Checking your session";
    return <div id="pnlInitialMessage" role="status" aria-live="polite">
        <p><strong>Are you ready?</strong></p>
        <div className="startup-progress" role="progressbar"
            aria-label="Application startup" aria-valuemin={0} aria-valuemax={3}
            aria-valuenow={completed} aria-valuetext={`${completed} of 3 steps complete. ${message}.`}>
            <div className="startup-progress-fill" style={{ width: `${completed / 3 * 100}%` }} />
        </div>
        <p className="startup-progress-label">{message} · {completed}/3</p>
    </div>;
}
